import { styled } from '@uhg-abyss/web/tools/styled';

import { mobileOnly } from '../../../ConstantsStyles';

export const BenefitContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  overflow: 'hidden',
  width: '100%',
  gap: '16px',
  flexShrink: 0,
  height: 'auto',
  [`@media ${mobileOnly}`]: {
    maxWidth: '100%',
  },
});

export const BenefitSubHeadingTextStyle = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
  width: '100%',
  maxWidth: '100%',
  overflow: 'hidden',
});

export const BenefitsSubHeadingContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '4px',
  alignSelf: 'stretch',
  width: '100%',
  maxWidth: '100%',
  variants: {
    isMobile: {
      true: {
        maxWidth: '100%',
      },
      false: {
        width: '1152px',
      },
    },
  },
});
